import type { GameNavSection } from '../models/game-section.model';

/**
 * Copy FIJO de la sección pública de juego (español de Costa Rica).
 *
 * Aquí vive solo lo que el front rotula por sí mismo. El copy **editorial**
 * —intro, párrafos, títulos de grupo, tagline— es contenido de base de datos
 * que escribe el admin desde el backoffice y llega en el payload de
 * `GET /api/web/games/{slug}`; no tiene nada que hacer en este fichero.
 *
 * Fijado literalmente por `game-section.constants.spec.ts`: si alguien cambia
 * una coma, el spec lo canta.
 */

/** Entradas del índice lateral. Cada `id` es el `id` del `<section>` de la página. */
export const GAME_NAV_SECTIONS: GameNavSection[] = [
  { id: 'que-es', label: '¿Qué es?' },
  { id: 'como-jugar', label: '¿Cómo jugar?' },
  { id: 'por-donde-empezar', label: '¿Por dónde empezar?' },
  { id: 'comunidad', label: 'Comunidad' },
  { id: 'blog', label: 'Blog' },
];

export const GAME_SECTION_COPY = {
  // Bloque "Comunidad"
  communityTitle: '¿Dónde y con quién jugar?',
  communitySubtitle:
    'Encuentra torneos, comunidades y lugares para jugar {game} en Costa Rica.',
  upcomingEventsLabel: 'Próximos eventos en Perrón Store',
  allEventsCta: 'Ver todos los eventos →',
  onlineLinksLabel: 'Comunidad online',
  localStoresLabel: 'Tiendas y lugares para jugar',
  communityLinkCta: 'Unirse →',
  communityTeaser: 'Próximamente: Encuentra jugadores cerca de ti',

  // Bloque "¿Por dónde empezar?"
  starterGuideTitle: '¿Por dónde empezar?',
  starterGuideSubtitle: 'Todo lo que necesitas para comenzar a jugar {game}.',

  // CTAs de catálogo
  starterGuideCta: 'Ver todos los productos de {game}',
  navCta: 'Ver catálogo de {shortName}',

  // Estados de la página
  notFound: 'Juego no encontrado.',
  loadError: 'No pudimos cargar esta sección. Intenta de nuevo.',
} as const;

/**
 * Sustituye los marcadores `{game}` y `{shortName}` del copy de arriba. Mismo
 * patrón que `interpolateCommunityText` en los bloques del home: si el texto no
 * trae el marcador se devuelve tal cual, y cualquier marcador desconocido se
 * deja intacto en vez de dejar un hueco.
 */
export function interpolateGameCopy(
  text: string,
  values: { game?: string | null; shortName?: string | null },
): string {
  if (!text) return '';
  return text.replace(/\{(game|shortName)\}/g, (match, key: string) => {
    const value = key === 'game' ? values.game : values.shortName;
    return value ? value : match;
  });
}
